/**
 * One-shot onboarding API client.
 *
 * The command bar renders an editable confirmation card (the
 * ``onboard_confirmation`` section). Its Confirm button calls
 * ``executeOnboarding`` — a single atomic server operation that
 * creates the employee and runs the whole pipeline, returning a
 * summary sentence. No second AI round trip.
 */
import client from "./client";

export interface OnboardExecutePayload {
  first_name: string;
  last_name: string;
  title: string;
  work_email: string;
  department_id?: string | null;
  manager_id?: string | null;
  start_date?: string | null; // ISO yyyy-mm-dd
  employment_type?: string;
}

export interface OnboardExecuteResult {
  employee_id: string;
  name: string;
  title: string;
  department: string | null;
  work_email: string;
  summary: string;
  onboarding: {
    documents_assigned: number;
    manager_notified: boolean;
    benefits_opened: boolean;
    welcome_email_sent: boolean;
    reviews_scheduled: number;
    lifecycle_started: boolean;
  };
  link: string;
}

export async function executeOnboarding(
  payload: OnboardExecutePayload,
): Promise<OnboardExecuteResult> {
  const res = await client.post<OnboardExecuteResult>(
    "/onboarding/execute",
    payload,
  );
  return res.data;
}
